import React from 'react';
import classes from './HeaderComponent.module.scss';
import { Avatar } from 'antd';
import { useAppDispatch, useAppSelector } from 'store/hook';
import Assets from 'assets/icons';
import cn from 'classnames';
import { setSelectedDocument, setViewType } from 'store/slices/dataDocumentsSlice';
import { useNavigate, useSearchParams } from 'react-router';
import { setDocumentToViewNull } from 'store/slices/viewerSlice';
import { setSelectedChatRoom } from 'store/slices/chatsSlice';
import { cleanDocumentViewUrl } from 'helpers/documentFiltersUrl';

type NameAvatarType = {
  name?: string
}

const NameAvatar = ({name}: NameAvatarType) => {
  const { selectedDocument, viewType } = useAppSelector((state) => state.documents);
  const { selectedChat } = useAppSelector((state) => state.chat);
  const { dataRoom } = useAppSelector((state) => state.dataRoom);
  const { documentToView } = useAppSelector((state) => state.viewer);

  const location = window.location.pathname;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const backToTable = () => {
    if (selectedChat?.entity_type === 0 && location.includes('chat')) {      
      dispatch(setSelectedChatRoom(null));
      navigate(`/room/${dataRoom!.id}/chat`);
    } else if (location.includes('/document/')) {
      if (selectedChat?.entity_type === 0) {
        navigate(`/room/${dataRoom!.id}/chat/document/${selectedChat.id}`);
      } else {
        navigate(`/room/${dataRoom!.id}/chat`);
        dispatch(setDocumentToViewNull());
        if (selectedChat?.entity_id === selectedDocument?.id) {
          dispatch(setSelectedChatRoom(null));
        }
      }
    } else {
      localStorage.setItem('prevViewedDocId', selectedDocument?.id || 'null')
      dispatch(setDocumentToViewNull());
      navigate(cleanDocumentViewUrl(window.location.pathname, searchParams));
    }
    dispatch(setViewType('Table'));
    dispatch(setSelectedDocument(null));
  };

  const displayedContent = {
    Table: (<Avatar
      className={classes.avatar}
      size={'large'}
    >
      <span className={classes.avatarWord}>
        {name ? name[0] : ''}
      </span>
    </Avatar>),
    Document:  <Assets.LeftIcon />,
    Report: null,
  };

  return (
    <div
      className={cn(classes.avatarWrap, selectedDocument ? classes.avatarPointer : 'null')}
      onClick={selectedDocument ? backToTable : undefined}
    >
      {displayedContent[viewType]}
    </div>
  );
}

export default NameAvatar;
